module.exports = __webpack_public_path__ + "static/media/logo_linkedin.da220646.svg";